export default {"src":"/_next/static/media/sign-icon.1e930c59.svg","height":160,"width":193,"blurWidth":0,"blurHeight":0};